import MFAEnrollment from './MFAEnrollment'

function ForceMFAEnrollment({ onComplete, onSignOut }) {
  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#012438' }}>
      {/* Left panel - branding */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden" style={{ backgroundColor: '#FAFAFF' }}>
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full" style={{ backgroundColor: '#8AD0D6', opacity: 0.08 }} />
        <div className="absolute -bottom-40 -left-40 rounded-full" style={{ width: '500px', height: '500px', backgroundColor: '#012438', opacity: 0.04 }} />
        <div className="absolute top-1/3 right-8 w-72 h-72 rounded-full" style={{ backgroundColor: '#BCC5CD', opacity: 0.12 }} />
        <div className="absolute top-16 left-1/3 w-48 h-48 rounded-full" style={{ backgroundColor: '#8AD0D6', opacity: 0.05 }} />
        <div className="absolute right-0 top-0 bottom-0 w-px" style={{ backgroundColor: '#BCC5CD' }} />

        <div className="relative z-10 flex flex-col justify-center px-16">
          <img src="/logo.png" alt="SSA Logo" className="w-16 h-16 rounded-2xl object-contain mb-8" />
          <h1 className="text-4xl font-bold leading-tight mb-3" style={{ color: '#012438' }}>
            Sidewalk Security Advisors
          </h1>
          <div className="w-12 h-1 rounded-full mb-5" style={{ backgroundColor: '#8AD0D6' }} />
          <p className="text-lg font-medium" style={{ color: '#3F5A6A' }}>
            Executive Advisory Platform
          </p>
        </div>

        <div className="absolute bottom-8 left-16">
          <p className="text-xs tracking-widest uppercase font-medium" style={{ color: '#7E8F9C' }}>
            Secure &middot; Strategic &middot; Advisory
          </p>
        </div>
      </div>

      {/* Right panel - MFA enrollment */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 sm:px-12" style={{ backgroundColor: '#012438' }}>
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden text-center mb-8">
            <img src="/logo.png" alt="SSA Logo" className="w-12 h-12 rounded-xl object-contain mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white">Sidewalk Security Advisors</h1>
            <p className="text-sm mt-1" style={{ color: '#7E8F9C' }}>Executive Advisory Platform</p>
          </div>

          {/* Step indicator */}
          <div className="flex items-center gap-2 mb-6">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold" style={{ backgroundColor: '#22c55e', color: '#fff' }}>
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <div className="flex-1 h-px" style={{ backgroundColor: '#8AD0D6' }} />
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold" style={{ backgroundColor: '#8AD0D6', color: '#012438' }}>2</span>
          </div>

          <div className="mb-6">
            <h2 className="text-2xl font-bold text-white">
              Set Up Two-Factor Authentication
            </h2>
            <p className="mt-2 text-sm" style={{ color: '#7E8F9C' }}>
              For security, your account requires two-factor authentication. Set up your authenticator app to continue.
            </p>
          </div>

          <MFAEnrollment
            inline={true}
            onComplete={onComplete}
            onCancel={onSignOut}
          />

          <div className="mt-6 text-center">
            <button
              onClick={onSignOut}
              className="text-sm font-medium transition-colors"
              style={{ color: '#7E8F9C' }}
              onMouseEnter={(e) => e.target.style.color = '#BCC5CD'}
              onMouseLeave={(e) => e.target.style.color = '#7E8F9C'}
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForceMFAEnrollment
